import React from "react";

import { useLocation } from "react-router-dom";

import Button from "ui/Button";
import { PagerDutyLogo } from "ui/Icons";
import { useAppConfig } from "providers/WithAppConfig";

import styles from "./style.module.scss";
import { useRoutes } from "utils/routes";
import { csrfTag } from "utils/csrf";

const ConnectToPagerDuty: React.FunctionComponent<{
  organizationSlug: string;
}> = ({ organizationSlug }) => {
  const config = useAppConfig();
  const { pathname } = useLocation();

  const { organizationIntegrationsPagerduty } = useRoutes();
  const pdAppId = config?.pagerDutyAppId;

  if (!pdAppId) {
    return (
      <button disabled className="btn btn-secondary disabled">
        <span className="flex items-center justify-center gap-1.5">
          <PagerDutyLogo />
          Not Available
        </span>
      </button>
    );
  }

  return (
    <form
      action={organizationIntegrationsPagerduty(organizationSlug)}
      method="post"
    >
      {csrfTag()}
      <input type="hidden" name="return_to" value={pathname} />
      <Button type="submit" className={styles.connectBtn}>
        <span className="flex items-center justify-center gap-1.5">
          <PagerDutyLogo />
          Connect to PagerDuty
        </span>
      </Button>
    </form>
  );
};

export default ConnectToPagerDuty;
